/**
 * @file  App.tsx
 * @description  Application entry point markup script
 *
 * @author ogarcia (ozkary)
 */
import React, { Suspense, useCallback, useEffect, useState } from 'react';
import './content/app.scss';

import Footer from './components/Footer';
import Header from './components/Header';
import Layout from './elements/Layout';
import EditionRouter from './routes/loader';
import { LayoutBackTop } from './elements/LayoutBackTop';
import Loading from './components/Loading';
import AuditTracker from './components/AuditTracker';
// import { loadSettings } from './services/settings';
import { signIn } from './functions/auth';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';

const App = (): JSX.Element => {

  const [appState, setAppState] = useState({loaded: false, token: ''});

  /**
   * loads the auth token and settings
   */
  const initialize = useCallback(async (loaded: boolean) => {
    if (!loaded){
      const token = await signIn();
      setAppState({loaded: true, token});
    }
    // await loadSettings();
  }, [appState.loaded]);

  // initialize app dependencies
  useEffect(() => {
    if (!appState.loaded) {
      initialize(appState.loaded);
    }    
  },[appState.loaded]);

  return (
    <Layout className="app">
      <AuditTracker/>
      <LayoutBackTop />
      <ErrorBoundary>
        <Suspense fallback={<Loading />}>
            <Layout.Header>
              <Header />
            </Layout.Header>
            <Layout.Content>
              <EditionRouter />
            </Layout.Content>
            <Layout.Footer>
              <Footer />
            </Layout.Footer>        
        </Suspense>
      </ErrorBoundary>
    </Layout>
  );
};

export default App;
